
<app-layout-row margin="0">
    <app-layout-column [width]="12">
        <div class="inputandmessage-container">
            <div class="typeandvalue">
                @if (!item()?.partnerFilledItem) {
                    <div>
                        <p class="field-label">{{item()?.itemName}}</p>
                        @if (item()?.itemType === 'file') {
                            <app-link [iconClass]="'dx-icon-download'" [disabled]="false" (onClick)="downloadFile(fileValue())">{{fileValue()?.FileName}}</app-link>
                        }
                        @else if (item()?.itemType === 'credentials') {
                            @if (supportsProvideCredentialsValue()) {
                                @if (credentialsStatusValue() === 'NotProvided') {
                                    <div class="no-credentials-container">
                                        <p>Not Provided</p>
                                        <app-link (onClick)="provideCredentials(item())">Provide credentials now</app-link>
                                    </div>
                                }
                                @else if (credentialsStatusValue() === 'Provided') {
                                    <div class="credentials-container">
                                        <p>Username: {{credentialsValue()?.Username}}</p>
                                        <p>Password: {{credentialsValue()?.Password ? '*****' : ''}}</p>
                                        <app-link [iconClass]="'dx-icon-edit'" (onClick)="provideCredentials(item())"></app-link>
                                    </div>
                                }
                                @else if (credentialsStatusValue() === 'Requested') {
                                    <div class="no-credentials-container">
                                        <p class="requested">Requested by partner</p>
                                        <app-link (onClick)="provideCredentials(item())">Provide credentials now</app-link>
                                    </div>
                                }
                            }
                            @else {
                                @if (credentialsStatusValue() === 'NotProvided') {
                                    <div class="no-credentials-container">
                                        <p>Not yet requested by partner</p>
                                    </div>
                                }
                                @else if (credentialsStatusValue() === 'Provided') {
                                    <div class="credentials-container">
                                        <p>Username: {{credentialsValue()?.Username}}</p>
                                        <p>Password: {{credentialsValue()?.Password ? '*****' : ''}}</p>
                                    </div>
                                }
                            }
                        }
                        @else {
                            <p>{{item()?.itemValue}}</p>
                        }
                    </div>
                } @else {
                    @if (item()?.itemType === 'password') {
                        <app-password [value]="passwordValue()" name="password" [caption]="item()?.itemName" [disabled]="false" [readonly]="true" [mode]="secretMode" [allowShowPassword]="true"></app-password>
                    }
                    @else if (item()?.itemType === 'file') {
                        <div>
                            <app-layout-control>
                                <p top class="field-label">{{item()?.itemName}}</p>
                                <app-link [iconClass]="'dx-icon-download'" [disabled]="false" (onClick)="downloadFile(fileValue())">{{fileValue()?.FileName}}</app-link>
                            </app-layout-control>
                        </div>
                    }
                    @else {
                        <app-textbox [ngModel]="item()?.itemValue" name="name" [caption]="item()?.itemName" [disabled]="false" [readonly]="true"></app-textbox>
                    }
                }

                <app-onboarding-comments-icon 
                    [hasUnreadMessages]="hasUnreadMessages(conversationData()?.conversationId)"
                    (clicked)="toggleConversation(conversationData()?.conversationId, conversationData()?.areaId)" 
                    [disabled]="false">
                </app-onboarding-comments-icon>
            </div>
            
            @if (conversationData()?.conversationId===conversationToShow()?.Id && conversationData()?.areaId===conversationToShow()?.AreaId) {
                <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="conversationData()?.autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation(conversationData()?.conversationId, conversationData()?.areaId)" [containerOffset]="conversationData()?.conversationContainerOffset">
                    <app-conversation 
                        [conversation]="conversationToShow()" 
                        (postNewMessageClicked)="newComment($event, conversationData()?.conversationId)">
                    </app-conversation>
                </app-onboarding-comments-container>
            }
        </div>
    </app-layout-column>
</app-layout-row>